export const eventFilters = [
  {
    category: 1,
    logo: `${process.env.PUBLIC_URL}/assets/img/event_all.svg`,
  },
  {
    category: 2,
    logo: `${process.env.PUBLIC_URL}/assets/img/event_culture.svg`,
  },
  {
    category: 3,
    logo: `${process.env.PUBLIC_URL}/assets/img/event_sport.svg`,
  },
  {
    category: 4,
    logo: `${process.env.PUBLIC_URL}/assets/img/event_festivals.svg`,
  },
  {
    category: 5,
    logo: `${process.env.PUBLIC_URL}/assets/img/event_kids.svg`,
  },
  {
    category: 6,
    logo: `${process.env.PUBLIC_URL}/assets/img/event_tickets.svg`,
  },
  {
    category: 7,
    logo: `${process.env.PUBLIC_URL}/assets/img/event_outdoor.svg`,
  },
  {
    category: 8,
    logo: `${process.env.PUBLIC_URL}/assets/img/event_others.svg`,
  },
];
